import questionnaire from '~/assets/qianfan/questionnaire-icon.png';
import kefu from '~/assets/qianfan/kefu-icon.svg';

const url = 'https://cloud.baidu.com/survey/qianfanpartnerconsultation.html';
const Index = () => {
    return (
        <>
            <div
                className="questionnaire"
                onClick={() => {
                    window.open(url, '_blank', 'noopener noreferrer');
                }}
            >
                <img src={questionnaire} alt="问卷调查" className="questionnaire-icon" />
            </div>
            <div
                className="float-button"
                onClick={() => {
                    window.open(
                        'https://cloud.baidu.com/survey/modelbuilder-product.html',
                        '_blank',
                        'noopener noreferrer'
                    );
                }}
            >
                <img src={kefu} alt="客服" className="kefu-icon" />
                <span className="float-button-text">售前咨询</span>
            </div>
        </>
    );
};

export default Index;
